import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import homeIcon from '../../static/home_icon.svg';
import myStoriesIcon from '../../static/my_stories_icon.svg';
import pricingIcon from '../../static/pricing_icon.svg';
import loginIcon from '../../static/login_icon.svg';
import createIcon from '../../static/create_icon.svg';
import createBookIcon from '../../static/Navbar/create_book.png';
import NavbarTab from './NavbarTab';
import { useNavigation } from '../../contexts/NavigationContext';
import { useUser } from '../../contexts/UserContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { sections } = useNavigation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  const { user } = useUser();

  // Map icons to section ids
  const sectionIcons: Record<string, string> = {
    'home': homeIcon,
    'my-stories': myStoriesIcon,
    // 'createStory': myStoriesIcon,
    'createStory': createBookIcon,
    'pricing': pricingIcon
  };

  const getUserInitial = () => {
    if (user && user.first_name) {
      return user.first_name.charAt(0).toUpperCase();
    }
    return 'U';
  };

  return (
    <nav className="navbar-figma">
      <Link to="/" onClick={closeMobileMenu}>
        <div className="navbar-logo-group">
          <img src={require('../../static/logo.png')} alt="Logo" className="navbar-logo" />
          <div className="navbar-logo-text">
            <span className="logo-child">Child</span>
            <span className="logo-story">Story Time</span>
          </div>
        </div>
      </Link>
      
      <div className="navbar-links">
        {sections
          .filter(section => section.isActive)
          .map(section => (
            <NavbarTab 
              key={section.id}
              to={section.path}
              label={section.label}
              icon={sectionIcons[section.id]}
              defaultColor="#151515"
              hoverColor={
                section.id === 'home' ? '#a21caf' : 
                section.id === 'my-stories' ? '#2563eb' : 
                section.id === 'createStory' ? '#2563eb' :
                '#f59e42'
              }
              hoverGradient={
                section.id === 'home' ? 'linear-gradient(180deg, #faf5ff 0%, #f3e8ff 100%)' : 
                section.id === 'my-stories' ? 'linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%)' : 
                section.id === 'createStory' ? 'linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%)' :
                'linear-gradient(180deg, #fffbeb 0%, #fef3c7 100%)'
              }
              showIconOnDefault={false}
            />
          ))}
      </div>
      
      {/* Mobile user avatar - only visible on mobile when user is signed in */}
      {user && (
        <Link to="/profile" className="mobile-user-avatar">
          {getUserInitial()}
        </Link>
      )}
      
      <div className="navbar-actions">
        {user ? (
          <Link to="/profile" className="user-avatar">
            {getUserInitial()}
          </Link>
        ) : (
          <Link to="/login" className="navbar-login-btn">
            <img src={loginIcon} alt="" className="navbar-btn-icon" />
            Log In
          </Link>
        )}
        <Link to="/create/1-write" className="navbar-create-btn">
          <img src={createIcon} alt="" className="navbar-btn-icon" />
          Create a Book
        </Link>
      </div>
      
      <button className="mobile-menu-button" onClick={toggleMobileMenu} aria-label="Toggle menu">
        <span className="hamburger-icon"></span>
        <span className="hamburger-icon"></span>
        <span className="hamburger-icon"></span>
      </button>
      
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-menu">
          <Link to="/" onClick={closeMobileMenu}>Home</Link>
          <Link to="/create/1-write" onClick={closeMobileMenu}>Create a Story</Link>
          {user ? (
            <Link to="/profile" onClick={closeMobileMenu}>Profile</Link>
          ) : (
            <Link to="/login" onClick={closeMobileMenu}>Log In</Link>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar; 